/* eslint-disable import/prefer-default-export */
export const ORIGINS = ['dropzone', 'tunnel', 'other'];
